import { WSTable, WSTableCell } from "@wingspanhq/fe-component-library";
import { PayeeRowAutoPayStrategy } from "@wingspanhq/wingspan-api-sdk";
import { queriesPayeeRows } from "@query";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { selectorSearchRowSecondaryName } from "../../../shared/selectors/selectorSearchRowSecondaryName";
import {
  pillAutopayOff,
  pillAutopayOn,
  useModalAutopaySettings
} from "./ModalAutopaySettings";

export const TablePayees: React.FC = () => {
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayeeRows = queriesPayeeRows.searchPayeeRows.useQuery({
    xWingspanAccount
  });

  const modalAutopaySettings = useModalAutopaySettings();

  return (
    <WSTable
      tableData={(queryPayeeRows.data?.data || []).map(payeeRow => {
        const name = selectorSearchRowName(payeeRow) || "--";

        return {
          id: payeeRow.id || "",
          data: {
            avatarText: name,
            primaryName: name,
            secondaryName: selectorSearchRowSecondaryName(payeeRow),
            autopay: payeeRow.autoPayStrategy === PayeeRowAutoPayStrategy.ALL
          }
        };
      })}
      columns={[
        {
          config: {
            header: {
              text: "Name"
            }
          },
          renderFunction: row => (
            <WSTableCell
              avatar={{
                type: "text",
                text: row.data.avatarText
              }}
              text={row.data.primaryName}
              secondaryText={row.data.secondaryName}
            />
          )
        },
        {
          config: {
            header: {
              text: "Autopay"
            }
          },
          renderFunction: row => (
            <WSTableCell
              pill={row.data.autopay ? pillAutopayOn : pillAutopayOff}
            />
          )
        }
      ]}
      rowMenuActions={row => [
        {
          icon: "settings",
          label: "Autopay settings",
          onClick: () => {
            modalAutopaySettings.open({
              payeeId: row.id
            });
          }
        }
      ]}
    />
  );
};
